import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { CloseRounded } from '@/components/Icons/CloseRounded';
import { AnalyticsEvent, useAnalytics } from '@/hooks/useAnalytics';
import { useController } from '@/hooks/useController';
import { useWidgetState } from '@/hooks/useWidgetState';
import { welcomeMessageSelector, widgetAlignmentSelector, } from '@/state/config';
import { isWidgetOpenState, openingMessageState } from '@/state/session';
export const OpeningMessage = () => {
    const { trackEvent } = useAnalytics();
    const welcomeMessage = useRecoilValue(welcomeMessageSelector);
    const [showOpeningMessage, setShowOpeningMessage] = useRecoilState(openingMessageState);
    const open = useRecoilValue(isWidgetOpenState);
    const { closeWidget } = useWidgetState();
    const { notifyOpeningMessageClosed } = useController();
    const widgetAlignment = useRecoilValue(widgetAlignmentSelector);
    useEffect(() => {
        setShowOpeningMessage(!!welcomeMessage);
    }, [setShowOpeningMessage, welcomeMessage]);
    useEffect(() => {
        if (open && showOpeningMessage) {
            setShowOpeningMessage(false);
        }
    }, [open, setShowOpeningMessage, showOpeningMessage]);
    const handleClose = useCallback(() => {
        trackEvent(AnalyticsEvent.CloseOpeningMessageClick);
        setShowOpeningMessage(false);
        closeWidget();
        notifyOpeningMessageClosed();
    }, [
        closeWidget,
        notifyOpeningMessageClosed,
        setShowOpeningMessage,
        trackEvent,
    ]);
    const handleKeyDown = useCallback(async (event) => {
        if (event.key === 'Enter') {
            handleClose();
        }
    }, [handleClose]);
    if (!showOpeningMessage) {
        return null;
    }
    return (_jsxs("div", { className: cn('animate-fade-in shadow-bubble bg-accent relative mb-1 ml-auto box-border flex w-max max-w-[200px] cursor-default rounded-sm p-2 px-3 text-sm', {
            'rounded-l-lg': widgetAlignment !== 'left',
            'rounded-r-lg': widgetAlignment === 'left',
        }), children: [_jsx("p", { className: "text-text-primary-foreground m-0", children: welcomeMessage }), _jsx("span", { role: "button", tabIndex: 0, className: cn('shadow-bubble bg-background absolute -top-3 -right-2 flex h-5 w-5 cursor-pointer items-center justify-center rounded-full p-1', {
                    '-left-2': widgetAlignment === 'left',
                }), onClick: handleClose, onKeyDown: handleKeyDown, children: _jsx(CloseRounded, { color: "var(--color-accent)" }) })] }));
};
